import { Chart } from 'primereact/chart';
import React from 'react';
import { merge } from 'lodash';

const BaseChart = (props) => {
    const { id, title, options, data, className, childClassName, chartClassName, type, chartTitle = false } = props;

    const styleOverrides = {
        scales: {
            x: {
                ticks: {
                    color: '#21060A'
                },
                grid: {
                    color: '#A69595'
                }
            },
            y: {
                ticks: {
                    color: '#21060A'
                },
                grid: {
                    color: '#A69595'
                }
            },
            ...(type === 'polarArea'
                ? {
                      r: {
                          grid: {
                              color: 'rgba(33, 6, 10, 0.4)'
                          },
                          ticks: {
                              color: '#21060A',
                              font: {
                                  size: 14,
                                  weight: 'bold'
                              }
                          }
                      }
                  }
                : {})
        },
        plugins: {
            legend: {
                labels: {
                    color: '#21060A'
                }
            },
            title: {
                display: chartTitle,
                text: title || '',
                color: '#21060A'
            }
        }
    };

    const mergedOptions = merge({}, styleOverrides, options);

    return (
        <div className={className}>
            <div className={childClassName}>
                <h4 className='text-lg font-bold text-theme1-primary2 mb-2'>{title}</h4>
                <Chart id={id} type={type} className={chartClassName} options={mergedOptions} data={data} />
            </div>
        </div>
    );
};

export default BaseChart;
